/**
 * Mando UI initialisation
 */

/* eslint-disable */
import Vue from "NodeModules/vue/dist/vue.min.js";

// Simple observable event bus to allow communication between components
Vue.prototype.$eventBus = new Vue();

import moment from "NodeModules/moment/moment";
import polyfillClosest from '../polyfill';
import cookieBanner from 'Components/entrade/_cookie/mando-ui.cookie';
import share from 'Components/entrade/share/mando-ui.share';
import table from 'Components/entrade/_rte-table/mando-ui.rte-table';

import videoHero from 'Components/entrade/hero/mando-ui.video-hero';
import heroCarousel from 'Components/entrade/hero/mando-ui.hero-carousel';
import communitySearchResults from 'Components/entrade/community-search-results/communitySearchResults.vue';

import headerAltOne from 'Components/entrade/header/header';
import navigationAltOne from 'Components/entrade/navigation/navigation';
import toTop from 'Components/entrade/_to-top/to-top';
document.addEventListener('DOMContentLoaded', () => {
  // Add JS helper class
  document.getElementsByTagName('html')[0].classList.remove('no-js');
  document.getElementsByTagName('html')[0].classList.add('has-js');

  //* Polyfill
  polyfillClosest();

  // Components
  headerAltOne();
  navigationAltOne();
  cookieBanner();
  share();
  table();
  videoHero();
  heroCarousel();
  toTop();
  
  const communitySearchResultsEl = document.querySelector('#community-search');

  Vue.filter('formatDate', (value) => {
    if (!value) {
      return '';
    }
    return moment(value).format('DD/MM/YY');
  });

  Vue.filter('formatFileSize', (value) => {
    return `${(value / Math.pow(1024, 1)).toFixed(2)}kB`;
  });

  Vue.filter('booleanToYesNo', value => ((value) ? 'Yes' : 'No'));

  if (communitySearchResultsEl) {
    /* eslint-disable no-new */
    new Vue({
      el: '#community-search',
      render: h =>
        h(communitySearchResults, {
          props: {
            options: JSON.parse(communitySearchResultsEl.dataset.options),
            searchConfig: communitySearchResultsEl.dataset.searchConfig,
            componentId: communitySearchResultsEl.dataset.componentId,
            siteId: communitySearchResultsEl.dataset.siteId,
            paging: communitySearchResultsEl.dataset.paging
          }
        })
    });
    /* eslint-enable */
  }
});


// WEBPACK FOOTER //
// ./src/scripts/brands/entrade.js